import { zapierConfig } from "@/content/site";

const toFormBody = (payload) => {
  const body = new URLSearchParams();
  Object.entries(payload).forEach(([key, value]) => {
    body.append(key, value == null ? "" : String(value));
  });
  return body;
};

const postToWebhook = async (url, payload) => {
  if (!url) {
    throw new Error("Webhook Zapier non configurato");
  }

  await fetch(url, {
    method: "POST",
    mode: "no-cors",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: toFormBody(payload),
  });
};

export const formApi = {
  createSopralluogoLead: (data) =>
    postToWebhook(zapierConfig.sopralluogoWebhook, {
      source: "sopralluogo_gratuito",
      submitted_at: new Date().toISOString(),
      ...data,
    }),

  createGuidaLead: (data) =>
    postToWebhook(zapierConfig.guidaWebhook, {
      source: "guida_gratuita",
      submitted_at: new Date().toISOString(),
      ...data,
    }),
};
